import { AnalyticsService } from '../services/analytics.service';
import type { TransactionDataSourceOptions } from '../transactions/transaction-data-source.class';
import { EVENT_TRANSACTION_ACTION_FAILED, EVENT_TRANSACTION_MANUALLY_CATEGORIZED } from './events';

/**
 * The outcome events for the core categorization loop, shaped once so every
 * transaction list reports identical properties. `method` and `suggested_count`
 * let PostHog compare workflows on one event instead of separate attempt events.
 */
export function transactionAnalyticsHooks(
  analytics: AnalyticsService,
): Pick<TransactionDataSourceOptions, 'onSuccessfulCategorization' | 'onFailedAction'> {
  return {
    onSuccessfulCategorization: outcome =>
      analytics.sendEvent(EVENT_TRANSACTION_MANUALLY_CATEGORIZED, {
        transaction_count: outcome.transactionCount,
        method: outcome.method,
        suggested_count: outcome.suggestedCount,
      }),
    onFailedAction: failure =>
      analytics.sendEvent(EVENT_TRANSACTION_ACTION_FAILED, {
        action: failure.action,
        ...(failure.status == null ? {} : { status: failure.status }),
      }),
  };
}
